import previewImg from "./images/pay-with-points.png";
import { POSPreview } from "./POSPreview";

export const PayWithPointsPreview: React.FC = () => {
  return (
    <POSPreview
      paragraph="Click “Create Transaction” and enter Total amount to pay in USD. Then enter points amount to withdraw in the “Pay with Points” field"
      imageSrc={previewImg}
    />
  );
};
